import { FC, useState, useEffect, useMemo } from "external/react"
import {clsx, styleAndCapture} from 'external/material'

type CrossIconToggleButtonProps = {
  boxSize?: number,
  strokeWidth?: number
  className?: string
  expanded?: boolean
  onChange?: (value:boolean) => void
}

const StyledCrossIconToggleButton = styleAndCapture('div', 'size')(crossIconToggleButtonStyles as any)

const CrossIconToggleButton: FC<CrossIconToggleButtonProps> = props => {

  const {boxSize = 32, expanded = false, onChange, className, strokeWidth = 2} = props
  const [value, setExpanded] = useState(expanded)

  useEffect(() => { if (expanded !== value) { setExpanded(expanded) }}, [expanded])

  function handleClick () {
    const newValue = !value
    setExpanded(newValue)
    onChange && setTimeout(() => onChange(newValue), 0)
  }
  
  const [viewBox, low, high, size] = useMemo(() => {
    const size = Math.floor(boxSize / 2)
    const viewBox = `0 0 ${boxSize} ${boxSize}`
    const low = Math.floor(size / 2)
    const high = low + size 
    return [viewBox, low, high, size]
  }, [boxSize])

  return (
    <StyledCrossIconToggleButton className={clsx('cross-icon-toggle-button', className)} onClick={handleClick} size={size}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        <line x1={low} y1={size} x2={high} y2={size}></line>
        {!value && <line x1={size} y1={low} x2={size} y2={high}></line>}
      </svg>
    </StyledCrossIconToggleButton>
  )
}

export {CrossIconToggleButton as default}

function crossIconToggleButtonStyles(props:any) {
  const {size} = props
  return {
    cursor: 'pointer',
    '& > svg': {
      width: size,
      height: size
    }
  }
}